const optionalKey = (key, value) => {
  if (!value || value === "") {
    return;
  }
  if (value instanceof Object && Object.values(value).every((v) => v === "")) {
    return;
  }
  return { [key]: value };
};
export {
  optionalKey
};
//# sourceMappingURL=optional-key.js.map
